import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import useDeviceType from "../../../global/Hooks/useDeviceType";

function ChartRenderer({ data, type }) {
  const chartFormatter = new Intl.NumberFormat("fa-IR");
  const deviceType = useDeviceType();
  const [barSize, setBarSize] = useState(30);

  useEffect(() => {
    if (deviceType === "mobile") setBarSize(10);
  }, [deviceType]);

  // type: 1 = Count, 2 = Area, 3 = Register
  const isArea = type === 2;

  // Rounded corners (top only looks best for stacked bars)
  const barRadius = [2, 2, 0, 0];

  return (
    <ResponsiveContainer width="100%" minHeight="22rem">
      <BarChart
        data={data}
        barSize={barSize}
        style={{ fontSize: "11px" }}
        margin={{
          top: 5,
          right: isArea ? 0 : 5,
          left:
            deviceType === "mobile" ? (isArea ? -35 : -45) : isArea ? 0 : -20,
          bottom: 15,
        }}
      >
        <CartesianGrid strokeDasharray={isArea ? "5 2" : "4 4"} />

        <XAxis
          dataKey="name"
          angle={-30}
          tickMargin={12}
          tickFormatter={(name) =>
            name.length > 12 ? `${name.slice(0, 12)}...` : name
          }
        />

        <YAxis
          tickMargin={deviceType === "mobile" ? 10 : 30}
          fontSize={deviceType === "mobile" ? "11px" : "13px"}
          tickFormatter={(value) => chartFormatter.format(value)}
        />

        <Tooltip
          cursor={{ fill: "rgba(0,0,0,0.04)" }}
          content={({ active, payload }) => {
            if (active && payload?.length) {
              const d = payload[0].payload;
              return (
                <div
                  style={{
                    background: "#fff",
                    padding: 10,
                    border: "1px solid #ccc",
                    borderRadius: 8,
                  }}
                >
                  <Typography color="#3592FB">
                    {type === 1
                      ? ` مجموع ساعات: ${chartFormatter.format(d.value)}`
                      : ` میانگین ساعات: ${chartFormatter.format(d.value)}`}
                  </Typography>
                </div>
              );
            }
            return null;
          }}
        />

        {/* Curved stacked bars */}
        <Bar dataKey="value" stackId="a" fill="#3592FB" radius={barRadius} />
        <Bar
          dataKey="value1"
          stackId="a"
          fill="rgba(154, 64, 224, 1)"
          radius={barRadius}
        />
        <Bar
          dataKey="value2"
          stackId="a"
          fill="rgba(76, 175, 80, 1)"
          radius={barRadius}
        />
        <Bar
          dataKey="value3"
          stackId="a"
          fill="rgba(255, 152, 0, 1)"
          radius={barRadius}
        />

        {/* invisible bar (same as your logic) */}
        {type !== 2 && (
          <Bar
            dataKey="value3"
            stackId="a"
            fill="rgba(255, 153, 0, 0)"
            radius={barRadius}
          />
        )}
      </BarChart>
    </ResponsiveContainer>
  );
}

export default ChartRenderer;
